import axios from "axios";

export const getTrainers = async (baseUrl, token) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  let getResponse = null;
  await axios
    .get(baseUrl + "/meeting/trainers", config)
    .then((res) => {
      getResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        getResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return getResponse;
};
export const deleteTrainer = async (baseUrl, token, trainerId) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  let deleteResponse = null;
  await axios
    .delete(baseUrl + "/meeting/trainer/" + trainerId, config)
    .then((res) => {
      deleteResponse = {
        status: res.data.status,
        data: res.data.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        deleteResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return deleteResponse;
};
export const upsertTrainer = async (baseUrl, token, trainer) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  let putResponse = null;
  await axios
    .put(baseUrl + "/meeting/trainer", trainer, config)
    .then((res) => {
      putResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        putResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return putResponse;
};
